import React from 'react';
import { useTranslation } from '@corti/i18n';
import { Base, Typography } from 'lib/cortiUI';
export function NoAnswer() {
    const { t } = useTranslation('caseView', { keyPrefix: 'assessment' });
    return (React.createElement(Base, { display: "flex", alignItems: "center", textAlign: "center" },
        React.createElement(Typography, { variant: "body2" }, t('questions.noAnswer', 'No Answer '))));
}
